import Collapse from '@material-ui/core/Collapse';
import clsx from 'clsx';
import { CART_OPEN } from 'constants/Images';
import Image from 'next/image';
import React, { useState } from 'react';
import styles from './styles.module.css';

interface Props {
  className?: string;
  children: React.ReactNode;
  maxHeight?: string | number;
  text?: string;
  disabled?: boolean;
  isBlur?: boolean;
  isOpen?: boolean;
}

const ReadMoreWrapper = ({ className, isBlur = true, isOpen = false, disabled = false, children, maxHeight = 100, text = 'Xem tất cả' }: Props) => {
  const [isReadMore, setIsReadMore] = useState(isOpen);

  const handleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  if (disabled) {
    return <>{children}</>;
  }

  return (
    <div className={clsx(className, styles.readMoreWrapper, { [styles.isReadMore]: isReadMore, [styles.isBlur]: isBlur })}>
      <Collapse collapsedSize={maxHeight} in={isReadMore}>
        {children}
      </Collapse>
      <div role="button" className={styles.readMoreAction} onClick={handleReadMore}>
        <p className={styles.textLink}>{!isReadMore ? text : 'Hiện ít hơn'}</p>
        <div className={styles.icon}>
          <Image src={CART_OPEN} width={16} height={16} alt="open icon" />
        </div>
      </div>
    </div>
  );
};

export default ReadMoreWrapper;
